/**
 * Центр карты по умолчанию. Москва
 */
export const DEFAULT_CENTER: [number, number] = [37.588144, 55.733842]
export const DEFAULT_DURATION = 500
export const DEFAULT_ZOOM = 16
export const DEFAULT_ZOOM_DURATION = 200
/**
 * Ключ useTransition для получения кастомизации
 */
export const MAP_CUSTOMIZATION_KEY = 'MAP_CUSTOMIZATION_KEY'
